import { useEffect, useState } from "react";
import { socket } from "../components/mediasoup/socket";

export interface RaisedHand {
  userId: string;
  name: string;
  cnr?: string;
  raisedAt: number;
}

export function useRaisedHands(roomId?: string, active = true, lobby = false) {
  const [hands, setHands] = useState<RaisedHand[]>([]);
  useEffect(() => {
    setHands([]);
    if (!roomId || !active) return;
    const update = (data: { roomId: string; hands: RaisedHand[] }) => {
      if (data.roomId === roomId) setHands(data.hands);
    };
    const reset = () => setHands([]);
    const event = lobby ? "lobby-raised-hands" : "raised-hands";
    const sync = () => socket.emit(lobby ? "get-lobby-raised-hands" : "get-raised-hands", { roomId });
    socket.on(event, update);
    socket.on("advocate_requests", sync);
    socket.on("disconnect", reset);
    socket.on("end-meeting", reset);
    socket.on("connect", sync);
    sync();
    return () => {
      socket.off(event, update);
      socket.off("advocate_requests", sync);
      socket.off("disconnect", reset);
      socket.off("end-meeting", reset);
      socket.off("connect", sync);
    };
  }, [roomId, active, lobby]);
  return active ? hands : [];
}
